import { apiClient } from './client';

/**
 * 지출 집행 — 「내 지출결의가 어떻게 됐나」 (2026-09-04 · 예산 판 B1).
 *
 * ★★ 금액은 **문자열로 받는다** — 숫자로 주고받으면 큰 값에서 자릿수가 조용히 깎인다.
 *    그릴 때만 숫자로 바꾼다.
 * ★ 옛 서버는 이 길이 없다(404) — 화면이 「아직 없습니다」로 접는다.
 */

export interface ExpenseLineDto {
  id: string;
  seq: number;
  spentOn: string | null;
  accountCode: string | null;
  accountLabel: string | null;
  description: string | null;
  amount: string;
  /** 어느 예산을 먹었나 — **못 붙었으면 `null`**(판 B3). 잘못이 아니라 사실이다. */
  budgetLineId: string | null;
  /** 「2026 회계연도 · 전사」 — 사람이 읽는 한 마디. */
  budgetName: string | null;
}

export interface ExpenseClaimDto {
  id: string;
  status: 'PENDING' | 'APPROVED' | 'REJECTED' | 'CANCELED' | string;
  totalAmount: string;
  payMethod: string | null;
  orgKind: string | null;
  orgId: string | null;
  documentId: string | null;
  documentTitle: string | null;
  documentStatus: string | null;
  drafterName: string;
  approvedAt: string | null;
  paidAt: string | null;
  createdAt: string;
  lines: ExpenseLineDto[];
}

export interface ExpenseAccountSummaryDto {
  code: string | null;
  label: string | null;
  /** 승인된 것 — **집행**이다. */
  approved: number;
  /** 결재가 도는 중인 것 — 집행이 아니다. */
  pending: number;
  lines: number;
}

export async function listExpenseClaims(params: {
  view: 'mine' | 'company';
  status?: string;
  limit?: number;
  cursor?: string;
}): Promise<{ claims: ExpenseClaimDto[]; nextCursor: string | null }> {
  const { data } = await apiClient.get<{ claims: ExpenseClaimDto[]; nextCursor: string | null }>(
    '/expense/claims',
    { params },
  );
  return { claims: data.claims ?? [], nextCursor: data.nextCursor ?? null };
}

export async function fetchExpenseSummary(params: {
  view: 'mine' | 'company';
  from?: string;
  to?: string;
}): Promise<{ accounts: ExpenseAccountSummaryDto[]; totalApproved: number; totalPending: number }> {
  const { data } = await apiClient.get<{
    accounts: ExpenseAccountSummaryDto[]; totalApproved: number; totalPending: number;
  }>('/expense/summary', { params });
  return {
    accounts: data.accounts ?? [],
    totalApproved: data.totalApproved ?? 0,
    totalPending: data.totalPending ?? 0,
  };
}
